<template>
    <div>
        <!--        <div class="input-field col s12 m6">
                    <select class="icons">
                        <option value="" disabled selected>Choose your option</option>
                        <option value="" data-icon="images/sample-1.jpg" class="left">example 1</option>
                        <option value="" data-icon="images/office.jpg" class="left">example 2</option>
                        <option value="" data-icon="images/yuna.jpg" class="left">example 3</option>
                    </select>
                    <label>Images in select</label>
                </div>-->

        <form class="col s12">
            <!--期权-->
            <section v-show="type == 'option'">
                <div class="row">
                    <div  class="input-field col s6">
                        <input v-model="form1.date1" :placeholder="this.en?'Vesting Date':'授予时间'" @click="clearErr('date1')" id="date1"  required type="date" class="validate">
                        <span v-show="error.date1.err" class="left error">{{error.date1.msg}}</span>
                        <label id="date1Label"  class="active"  :data-error="error.date1.msg" for="date1">{{'授予时间'|language}}</label>
                    </div>
                    <div class="input-field col s6">
                        <input id="total1"  readonly v-model="total1" min="0"  type="number" class="validate">
                        <span v-show="error.total1.err" class="left error">{{error.total1.msg}}</span>
                        <label  class="active" :data-error="error.total1.msg"  for="total1">{{'授予总数'|language}}</label>
                    </div>
                </div>
                <div class="row">
                    <div class="input-field col s6">
                        <input @input="check('kxq')" id="kxq" v-model="form1.kxq" min="0" required type="number" class="validate">
                        <span v-show="error.kxq.err" class="left error">{{error.kxq.msg}}</span>
                        <label class="active" :data-error="error.kxq.msg"  for="kxq">{{'可行权'|language}}</label>
                    </div>
                    <div class="input-field col s6">
                        <input @input="check('yxq')" id="yxq" v-model="form1.yxq" min="0" required type="number" class="validate">
                        <span v-show="error.yxq.err" class="left error">{{error.yxq.msg}}</span>
                        <label class="active" :data-error="error.yxq.msg"  for="yxq">{{'已行权'|language}}</label>
                    </div>
                </div>
                <div class="row">
                    <div class="input-field col s6">
                        <input @input="check('wcs')" id="wcs" v-model="form1.wcs" min="0" required type="number" class="validate">
                        <span v-show="error.wcs.err" class="left error">{{error.wcs.msg}}</span>
                        <label class="active" :data-error="error.wcs.msg" for="wcs">{{'未行权'|language}}</label>
                    </div>
                    <div class="input-field col s6">
                        <input @input="check('yhs1')" id="yhs1" v-model="form1.yhs1" min="0" required type="number" class="validate">
                        <span v-show="error.yhs1.err" class="left error">{{error.yhs1.msg}}</span>
                        <label class="active" :data-error="error.yhs1.msg" for="yhs1">{{'已回收'|language}}</label>
                    </div>
                </div>
                <div class="row">
                    <div class="input-field col s6">
                        <input @input="check('xqjg')" id="xqjg" v-model="form1.xqjg" min="0" required type="number" class="validate">
                        <span v-show="error.xqjg.err" class="left error">{{error.xqjg.msg}}</span>
                        <label class="active" :data-error="error.xqjg.msg" for="xqjg">{{'行权价格'|language}}</label>
                    </div>
                </div>
            </section>
            <!--限售股-->
            <section v-show="type == 'rsu'">
                <div class="row">
                    <div class="input-field col s6">
                        <input v-model="form2.date2" :placeholder="this.en?'Vesting Date':'授予时间'"  @click="clearErr('date2')" id="date2" type="date" class="validate">
                        <span v-show="error.date2.err" class="left error">{{error.date2.msg}}</span>
                        <label id="date2Label" class="active"    :data-error="error.date2.msg" for="date2">{{'授予时间'|language}}</label>
                    </div>
                    <div class="input-field col s6">
                        <input readonly id="total2" v-model="total2" type="number" class="validate">
                        <span v-show="error.total2.err" class="left error">{{error.total2.msg}}</span>
                        <label class="active" :data-error="error.total2.msg" for="total2">{{'授予总数'|language}}</label>
                    </div>
                </div>
                <div class="row">
                    <div class="input-field col s6">
                        <input @input="check('yjj')" id="yjj" type="number" v-model="form2.yjj" class="validate">
                        <span v-show="error.yjj.err" class="left error">{{error.yjj.msg}}</span>
                        <label class="active" :data-error="error.yjj.msg" for="yjj">{{'已解禁'|language}}</label>
                    </div>
                    <div class="input-field col s6">
                        <input @input="check('wjj')" id="wjj" type="number" v-model="form2.wjj" class="validate">
                        <span v-show="error.wjj.err" class="left error">{{error.wjj.msg}}</span>
                        <label class="active" :data-error="error.wjj.msg" for="wjj">{{'未解禁'|language}}</label>
                    </div>
                </div>
                <div class="row">
                    <div class="input-field col s6">
                        <input @input="check('yhs2')" id="yhs2" v-model="form2.yhs2" type="number" class="validate">
                        <span v-show="error.yhs2.err" class="left error">{{error.yhs2.msg}}</span>
                        <label class="active" :data-error="error.yhs2.msg" for="yhs2">{{'已回收'|language}}</label>
                    </div>
                </div>
            </section>
        </form>
    </div>
</template>

<script>
    import { HttpClient } from '../../util/http';
    import { toast } from '../../util/alert';
    import * as dayjs from 'dayjs';
import { languageTranslation } from '../../util/language';
    export default {
        name: 'StockInput',
        data() {
            return {
                type: this.innerType,// option期权，rsu限售股
                companyId: '',
                stockId: '',
                dayjs: dayjs,
                form1: {
                    date1: dayjs(new Date()).format('YYYY-MM-DD'),
                    kxq: '',
                    yxq: '',
                    wcs: '',
                    yhs1: '',
                    total1: '',
                    xqjg: ''
                },
                error:{ // 表单验证
                    date1:{
                        err: false,
                        msg: ''
                    },
                    kxq:{
                        err: false,
                        msg: ''
                    },
                    yxq:{
                        err: false,
                        msg: ''
                    },
                    wcs:{
                        err: false,
                        msg: ''
                    },
                    yhs1:{
                        err: false,
                        msg: ''
                    },
                    total1:{
                        err: false,
                        msg: ''
                    },
                    xqjg:{
                        err: false,
                        msg: ''
                    },
                    date2:{
                        err: false,
                        msg: ''
                    },
                    yjj:{
                        err: false,
                        msg: ''
                    },
                    wjj:{
                        err: false,
                        msg: ''
                    },
                    total2:{
                        err: false,
                        msg: ''
                    },
                    yhs2:{
                        err: false,
                        msg: ''
                    }
                },
                form2: {
                    date2: dayjs(new Date()).format('YYYY-MM-DD'),
                    yjj: '',
                    wjj: '',
                    total2: '',
                    yhs2: ''
                },
                instance: null
            };
        },
        props:{
          innerType: {
              type:String,
              default: 'option'
          }
        },
        watch:{

        },
        computed: {
            total1() {
                let count = Number(this.form1.kxq === '' ? 0:this.form1.kxq)
                    + Number(this.form1.yxq === '' ? 0:this.form1.yxq)
                    + Number(this.form1.wcs === '' ? 0:this.form1.wcs)
                    - Number(this.form1.yhs1 === '' ? 0:this.form1.yhs1)
                if(Number(count)<0){
                    $('#total1').removeClass('valid')
                    $('#total1').addClass('invalid')
                    this.error.total1.err = true
                    this.error.total1.msg = this.en?'Total must be over 0,Total = Exercisable + Exercised + Unexercisable - Forfeitures':'授予总数不能小于0,授予总数 = 可行权 + 已行权 + 未行权 - 已回收'
                }else {
                    $('#total1').removeClass('invalid')
                    $('#total1').addClass('valid')
                    this.error.total1.err = false
                    this.error.total1.msg = ''
                }
                return Number(count)
            },
            total2() {
                let count = 0 + Number(this.form2.yjj === '' ? 0:this.form2.yjj)
                    + Number(this.form2.wjj === '' ? 0:this.form2.wjj)
                    - Number(this.form2.yhs2 === '' ? 0:this.form2.yhs2)
                if(Number(count)<0){
                    $('#total2').removeClass('valid')
                    $('#total2').addClass('invalid')
                    this.error.total2.err = true
                    this.error.total2.msg = this.en? 'Total must be over 0, Total = Exercised + Unexercisable - Forfeitures' :'授予总数不能小于0，授予总数 = 已解禁 +  未解禁 - 已回收'
                }else {
                    $('#total2').removeClass('invalid')
                    $('#total2').addClass('valid')
                    this.error.total2.err = false
                    this.error.total2.msg = ''
                }
                return count
            },
            en() {
                return location.pathname.indexOf('/en') == -1 ? '' : '/en';
            },
        },
        mounted() {
            /*  console.log($('#date1').val()) 日期的值 */
            this.type = this.innerType;
            M.AutoInit();
            this.$nextTick(() => {
                M.updateTextFields();
            });
        },
        updated(){
            this.$nextTick( ()=>{

            } )
            $("#date2Label").removeClass()
            $("#date1Label").removeClass()
            $("#date2Label").addClass('active')
            $("#date1Label").addClass('active')
        },
        methods: {
            init(params){
                M.AutoInit();
                this.$nextTick( ()=>{
                    M.updateTextFields();
                } )
                this.form1 ={
                    date1: dayjs(new Date()).format('YYYY-MM-DD'),
                    kxq: '',
                    yxq: '',
                    wcs: '',
                    yhs1: '',
                    total1: '',
                    xqjg: ''
                }
                this.form2 = {
                    date2: dayjs(new Date()).format('YYYY-MM-DD'),
                    yjj: '',
                    wjj: '',
                    total2: '',
                    yhs2: ''
                }
                this.stockId = params.id
                if (params.id!== undefined && params.id!== null && params.id!== ''){
                    let data = {
                        model: 'Stock',
                        cond: params.id,
                    }
                    this.getStock(data)
                }else {
                    this.companyId = params.company
                    this.type = params.type
                }

            },
            changeType(type){
                this.type = type
            },
            async getStock(data) {
                let { result } = await HttpClient.post('/restful', {
                    ...data
                });
                console.log(result)
                this.type = result.type;
                if(result.type == 'option'){
                    this.form1 = {
                        date1: result.date,
                        kxq: result.kxq,
                        yxq: result.yxq,
                        wcs: result.wcs,
                        yhs1: result.yhs,
                        total1: result.total,
                        xqjg: Number(result.xqjg)
                    }
                    this.companyId = result.company
                }else {
                    this.form2 = {
                        date2: result.date,
                        yjj: result.yjj,
                        wjj: result.wjj,
                        total2: result.total,
                        yhs2: Number(result.yhs)
                    }
                    this.companyId = result.company
                }
                this.$nextTick( ()=>{
                    M.updateTextFields();
                } )

            },
            check(val){
                switch (val) {
                    case 'date1':
                        if( this.form1.date1== '' || this.form1.date1 == null){
                            this.error.date1.err = true
                            this.error.date1.msg = this.en ? 'Please enter Vesting Date':'请输入授予时间'
                        }else {
                            this.error.date1.err = false
                            this.error.date1.msg = ''
                        }
                        break
                    case 'total1':
                        if(this.total1 == '' || this.total1 == null){
                            $('#total1').removeClass('valid')
                            $('#total1').addClass('invalid')
                            this.error.total1.err = true
                            this.error.total1.msg = this.en ? 'Please enter Total':'请输入授予总数'
                        }else if (Number(this.total1)<0) {
                            $('#total1').removeClass('valid')
                            $('#total1').addClass('invalid')
                            this.error.total1.err = true
                            this.error.total1.msg = this.en?'Total must be over 0,Total = Exercisable + Exercised + Unexercisable - Forfeitures':'授予总数不能小于0,授予总数 = 可行权 + 已行权 + 未行权 - 已回收'
                        }else {
                            $('#total1').removeClass('invalid')
                            $('#total1').addClass('valid')
                            this.error.total1.err = false
                            this.error.total1.msg = ''
                        }
                        break
                    case 'kxq':
                        if( this.form1.kxq == '' || this.form1.kxq == null){
                            this.error.kxq.err = true
                            this.error.kxq.msg = this.en ? 'Please enter Exercisable':'请输入可行权数量'
                        }else if (Number( this.form1.kxq)<0) {
                            this.error.kxq.err = true
                            this.error.kxq.msg = this.en ? 'Exercisable must be over 0':'可行权数量不能小于0'
                        }else {
                            this.error.kxq.err = false
                            this.error.kxq.msg = ''
                        }
                        break
                    case 'yxq':
                        if( this.form1.yxq == '' || this.form1.yxq == null){
                            this.error.yxq.err = true
                            this.error.yxq.msg = this.en ? 'Please enter Exercised':'请输入已行权数量'
                        }else if (Number(this.form1.yxq)<0) {
                            this.error.yxq.err = true
                            this.error.yxq.msg = this.en ? 'Exercised must be over 0':'已行权数量不能小于0'
                        }else {
                            this.error.yxq.err = false
                            this.error.yxq.msg = ''
                        }
                        break
                    case 'wcs':
                        if( this.form1.wcs == '' || this.form1.wcs == null){
                            this.error.wcs.err = true
                            this.error.wcs.msg = this.en ? 'Please enter Unexercisable':'请输入未行权数量'
                        }else if (Number(this.form1.wcs)<0) {
                            this.error.wcs.err = true
                            this.error.wcs.msg = this.en ? 'Unexercisable must be over 0':'未行权数量不能小于0'
                        }else {
                            this.error.wcs.err = false
                            this.error.wcs.msg = ''
                        }
                        break
                    case 'yhs1':
                        if( this.form1.yhs1 == '' || this.form1.yhs1  == null){
                            this.error.yhs1.err = true
                            this.error.yhs1.msg = this.en ? 'Please enter Forfeitures':'请输入已回收数量'
                        }else if (Number(this.form1.yhs1 )<0) {
                            this.error.yhs1.err = true
                            this.error.yhs1.msg = this.en ? 'Exercised must be over 0': '已解禁数量不能小于0'
                        }else {
                            this.error.yhs1.err = false
                            this.error.yhs1.msg = ''
                        }
                        break
                    case 'xqjg':
                        if( this.form1.xqjg  == '' || this.form1.xqjg  == null){
                            this.error.xqjg.err = true
                            this.error.xqjg.msg = languageTranslation('请输入行权价格')
                        }else if (Number(this.form1.xqjg)<0) {
                            this.error.xqjg.err = true
                            this.error.xqjg.msg = '行权价格不能小于0'
                        }else {
                            this.error.xqjg.err = false
                            this.error.xqjg.msg = ''
                        }
                        break
                    case 'date2':
                        if(this.form2.date2 == '' ||this.form2.date2 == null){
                            this.error.date2.err = true
                            this.error.date2.msg = this.en ? 'Please enter Vesting Date':'请输入授予时间'
                        }else {
                            this.error.date2.err = false
                            this.error.date2.msg = ''
                        }
                        break
                    case 'total2':
                        if( this.total2 == '' || this.total2 == null){
                            this.error.total2.err = true
                            this.error.total2.msg = this.en ? 'Please enter Total':'请输入授予总数'
                            $('#total2').removeClass('valid')
                            $('#total2').addClass('invalid')
                        }else if (Number(this.total2)<0) {
                            $('#total2').removeClass('valid')
                            $('#total2').addClass('invalid')
                            this.error.total2.err = true
                            this.error.total2.msg = this.en? 'Total must be over 0, Total = Exercised + Unexercisable - Forfeitures' :'授予总数不能小于0，授予总数 = 已解禁 +  未解禁 - 已回收'
                        }else {
                            $('#total2').removeClass('invalid')
                            $('#total2').addClass('valid')
                            this.error.total2.err = false
                            this.error.total2.msg = ''
                        }
                        break
                    case 'yjj':
                        if( this.form2.yjj == '' || this.form2.yjj == null){
                            this.error.yjj.err = true
                            this.error.yjj.msg = this.en ? 'Please enter Exercised': '请输入已解禁数量'
                        }else if (Number(this.form2.yjj)<0) {
                            this.error.yjj.err = true
                            this.error.yjj.msg = this.en ? 'Exercised must be over 0': '已解禁数量不能小于0'
                        }else {
                            this.error.yjj.err = false
                            this.error.yjj.msg = ''
                        }
                        break
                    case 'wjj':
                        if( this.form2.wjj == '' || this.form2.wjj == null){
                            this.error.wjj.err = true
                            this.error.wjj.msg = this.en ? 'Please enter Unexercisable':'请输入未解禁数量'
                        }else if (Number(this.form2.wjj)<0) {
                            this.error.wjj.err = true
                            this.error.wjj.msg = this.en ? 'Unexercisable must be over 0': '未解禁数量不能小于0'
                        }else {
                            this.error.wjj.err = false
                            this.error.wjj.msg = ''
                        }
                        break
                    case 'yhs2':
                        if( this.form2.yhs2 == '' || this.form2.yhs2 == null){
                            this.error.yhs2.err = true
                            this.error.yhs2.msg = this.en ? 'Please enter Forfeitures':'请输入已回收数量'
                        }else if (Number(this.form2.yhs2)<0) {
                            this.error.yhs2.err = true
                            this.error.yhs2.msg = this.en ? 'Forfeitures must be over 0':'已回收数量不能小于0'
                        }else {
                            this.error.yhs2.err = false
                            this.error.yhs2.msg = ''
                        }
                        break
                }
            },
            clearErr(val) {
                this.error[val]['err']= false
                this.error[val]['msg']= ''
            },
            onSubmit(){
                let userid = ''
                if(localStorage.djhusermodelpc1 !== null &&localStorage.djhusermodelpc1 !==undefined ){
                    userid = JSON.parse(localStorage.djhusermodelpc1)._id
                }
                if(this.type == 'option'){
                    for(let attr in this.form1){
                        this.check(attr)
                        if(this.error[attr]['err']){
                            return
                        }
                    }
                    let data = {
                        updates:{
                            date: this.form1.date1,
                            kxq: Number(this.form1.kxq),
                            yxq: Number(this.form1.yxq),
                            wcs:  Number(this.form1.wcs),
                            yhs: Number(this.form1.yhs1),
                            total: Number(this.total1),
                            xqjg:  Number(this.form1.xqjg),
                            type: 'option',
                            company: this.companyId,
                            user: userid
                        },
                        model: 'Stock',
                        cond: this.stockId === undefined ? null : this.stockId ,
                    }
                    this.doSubmit(data)
                }else{
                    for(let attr in this.form2){
                        this.check(attr)
                        if(this.error[attr]['err']){
                            return
                        }
                    }
                    let data = {
                        updates:{
                            date: this.form2.date2,
                            yjj: Number(this.form2.yjj),
                            wjj: Number(this.form2.wjj),
                            yhs: Number(this.form2.yhs2),
                            total: Number(this.total2),
                            type: 'rsu',
                            company: this.companyId,
                            user: userid
                        },
                        model: 'Stock',
                        cond: this.stockId === undefined ? null : this.stockId ,
                    }
                    this.doSubmit(data)
                }
            },
            async doSubmit(data){
                let stock = await HttpClient.put('/restful', {
                    ...data
                });
                toast( this.en?'submit successfully':'提交成功')
                this.$emit('hasSubmited',stock)
                this.stockId = stock._id
            }
        },
    };
</script>
<style lang="less" scoped>
    .content{
        max-width: 1300px;
        min-width: 90%;
        margin-top: 5%;
        text-align: center;
        .iconFont{
            transform: translate(0,15%);
            width: 19px;
            height: 19px;
        }
        input[type="number"]::-webkit-inner-spin-button {
            -webkit-appearance: none;
        }
        input[type="date"]::-webkit-inner-spin-button {
            -webkit-appearance: none;
        }
        input[type="date"]::-webkit-datetime-edit {
            -webkit-appearance: none;
        }
    }
    section{
        margin-top: 2rem;
    }
    .bgcolor{
        background: #BA2730;
    }
    .error{
        color: red;
    }
</style>
